function MenuBarButton({ showMenu, setShowMenu }) {
  return (
    <button
      className='MenuBarButton group p-1 rounded-lg hover:bg-slate-700 relative md:hidden'
      onClick={(e) => {
        setShowMenu(!showMenu);
        if (showMenu) e.currentTarget.blur();
      }}
    >
      <div className='MenuBarButtonIn relative flex h-[33px] w-[33px] transform items-center justify-center overflow-hidden shadow-md transition-all duration-200 rounded-lg group-focus:bg-slate-800 '>
        <div className='lines flex h-[20px] w-[20px] origin-center transform flex-col justify-between overflow-hidden transition-all duration-300 '>
          <div className='první h-[2px] w-7 origin-left transform bg-white transition-all duration-300 group-focus:translate-x-10'></div>
          <div className='druhá h-[2px] w-7 transform rounded bg-white transition-all delay-75 duration-300 group-focus:translate-x-10'></div>
          <div className='třetí h-[2px] w-7 origin-left transform bg-white transition-all delay-150 duration-300 group-focus:translate-x-10'></div>

          <div className='absolute top-2.5 flex w-0 -translate-x-10 transform items-center justify-between transition-all duration-500 group-focus:w-12 group-focus:translate-x-0'>
            <div className='absolute h-[2px] w-5 rotate-0 transform bg-white transition-all delay-300 duration-500 group-focus:rotate-45'></div>
            <div className='absolute h-[2px] w-5 -rotate-0 transform bg-white transition-all delay-300 duration-500 group-focus:-rotate-45'></div>
          </div>
        </div>
      </div>
    </button>
  );
}

export default MenuBarButton;
